import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, Teleport as _Teleport, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"


export default /*#__PURE__*/_defineComponent({
  ...{ name: 'MobileOverlayLayer' },
  __name: 'MobileOverlayLayer',
  props: {
    active: { type: Boolean }
  },
  setup(__props: any) {

/**
 * Overlays filhos de um `FullScreenPanel` (sidebars e modais `fixed z-50` que hoje
 * são IRMÃOS do modal no template). O painel faz teleport para o fim do `#app`;
 * irmãos renderizados no lugar ficam ANTES dele no DOM e, com o mesmo z-index,
 * pintam por baixo. Ativo, este componente leva os overlays para o `#app` depois do
 * painel (o teleport do painel monta primeiro, então a âncora dele vem antes).
 *
 * Inativo (desktop) não há teleport nenhum: o DOM é exatamente o de antes.
 */




return (_ctx: any,_cache: any) => {
  return (_ctx.active)
    ? (_openBlock(), _createBlock(_Teleport, {
        key: 0,
        to: "#app"
      }, [
        _renderSlot(_ctx.$slots, "default")
      ]))
    : _renderSlot(_ctx.$slots, "default", { key: 1 })
}
}

})